const initialState = {
    isOpen: false,
    isActive: false,
};
const modalSuccessMsg = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_SUCCESS_MSG':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalSuccessMsg;
